module.exports = __webpack_public_path__ + "static/fonts/SFPro.9e14b4e.ttf";